@if(!alinhamentoLateral){
  <div class="flex-direction-column gap-5">
    <span class="font-12 weight-600">Horário</span>
    <input
      class="input-time-picker"
      matInput
      placeholder="00:00"
      [value]="tempo"
      [disabled]="disabled"
      (input)="receberValor($event)"
    />
  </div>
}
@else{
  <div class="time-picker-lateral">
    @if(labelExtra !== "") {
      <span class="time-picker-lateral__extra">{{labelExtra}}</span>
    }
    <span class="font-12 time-picker-lateral__label">Horário</span>
    <input
      class="input-time-picker time-picker-lateral__input"
      matInput
      placeholder="00:00"
      [value]="tempo"
      [disabled]="disabled"
      (input)="receberValor($event)"
    />
  </div>
}
